import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-application',
  templateUrl: './fh-svg-application.component.html',
  styleUrl: './fh-svg-application.component.scss'
})
export class FhSvgApplicationComponent {
  @Input() color: string = '';
}
